import { noDataFoundEmptyState, plusWhite } from '../../../../assets/hostedassets';
import { PEC_PICKER_LABELS } from '../../DealDrawerConstants';
import Button from '../../../_custom/Button/Button';
import styles from './StepEmptyState.module.scss';

interface StepEmptyStateProps {
    onAdd: () => void;
}

export const StepEmptyState: React.FC<StepEmptyStateProps> = ({ onAdd }) => (
    <div className={styles.EmptyState}>
        <img src={noDataFoundEmptyState} alt="" className={styles.EmptyImage} />
        <span className={styles.EmptyText}>{PEC_PICKER_LABELS.emptyText}</span>
        <Button
            type="button"
            variant="purple"
            text={PEC_PICKER_LABELS.addPreferences}
            icon={plusWhite}
            iconSize="14"
            onClick={onAdd}
            className={styles.AddButton}
        />
    </div>
);

export default StepEmptyState;
